var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_c('span',{staticClass:"title-point"},[_vm._v("·")]),_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"title-point"},[_vm._v("·")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }